import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { isAssessmentStudent } from './assessmentStudent';
import { hasRole, hasAnyRole } from './roleUtils';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  const location = useLocation();
  const { user, loading } = useUser();

  if (!token) {
    // Save the intended URL so Login can redirect back after authentication
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?redirectTo=${redirectTo}`} replace />;
  }
   // Students may only use assessment + test execution routes
   if (!loading && isAssessmentStudent(user)) {
    const path = location.pathname;
    const allowed =
      path === '/assessment' ||
      path.startsWith('/assessment/') ||
      path.startsWith('/execution/');
    if (!allowed) {
      return <Navigate to="/assessment" replace />;
    }
  }

  // If token is present but user context is not loaded yet, show loading spinner
  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-red-600"></div>
      </div>
    );
  }

  // Restrict access for Intern role (role_id = 16)
  if (hasRole(user, 16)) {
    const allowedPaths = ['/home', '/timesheet', '/profile'];
    const isAllowed = allowedPaths.some(path => location.pathname.startsWith(path));
    if (!isAllowed) {
      return <Navigate to="/home" replace />;
    }
  }

  // Restrict access for Client (role_id = 2) and Client Admin (role_id = 17)
  if (hasAnyRole(user, [2, 17])) {
    const allowedPaths = ['/tickets', '/profile', '/dashboard', '/Dashboard'];
    const isAllowed = allowedPaths.some(path => location.pathname.startsWith(path));
    if (!isAllowed) {
      return <Navigate to="/tickets" replace />;
    }
  }

  return children;
}

export default PrivateRoute;
